export const onCreateRole = /* GraphQL */ `
  subscription onCreateRole($filter: ModelSubscriptionRoleFilterInput, $ownerId: String) {
  onCreateRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const onCreateRolePermission = /* GraphQL */ `
  subscription onCreateRolePermission($filter: ModelSubscriptionRolePermissionFilterInput, $ownerId: String) {
  onCreateRolePermission(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      objectId
      objectType
      ownerId
      roleId
      workspaceId
  }
}
`;

export const onCreateUserRole = /* GraphQL */ `
  subscription onCreateUserRole($filter: ModelSubscriptionUserRoleFilterInput, $ownerId: String) {
  onCreateUserRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      ownerId
      roleId
      userId
      workspaceId
  }
}
`;

export const onDeleteRole = /* GraphQL */ `
  subscription onDeleteRole($filter: ModelSubscriptionRoleFilterInput, $ownerId: String) {
  onDeleteRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const onDeleteRolePermission = /* GraphQL */ `
  subscription onDeleteRolePermission($filter: ModelSubscriptionRolePermissionFilterInput, $ownerId: String) {
  onDeleteRolePermission(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      objectId
      objectType
      ownerId
      roleId
      workspaceId
  }
}
`;

export const onDeleteUserRole = /* GraphQL */ `
  subscription onDeleteUserRole($filter: ModelSubscriptionUserRoleFilterInput, $ownerId: String) {
  onDeleteUserRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      ownerId
      roleId
      userId
      workspaceId
  }
}
`;

export const onUpdateRole = /* GraphQL */ `
  subscription onUpdateRole($filter: ModelSubscriptionRoleFilterInput, $ownerId: String) {
  onUpdateRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      description
      displayName
      id
      includeFutureConfig
      key
      ownerId
      updatedAt
      updatedBy
      workspaceId
  }
}
`;

export const onUpdateRolePermission = /* GraphQL */ `
  subscription onUpdateRolePermission($filter: ModelSubscriptionRolePermissionFilterInput, $ownerId: String) {
  onUpdateRolePermission(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      objectId
      objectType
      ownerId
      roleId
      workspaceId
  }
}
`;

export const onUpdateUserRole = /* GraphQL */ `
  subscription onUpdateUserRole($filter: ModelSubscriptionUserRoleFilterInput, $ownerId: String) {
  onUpdateUserRole(filter: $filter, ownerId: $ownerId) {
      createdAt
      createdBy
      id
      ownerId
      roleId
      userId
      workspaceId
  }
}
`;
